import React, { useEffect } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import useMedia from 'use-media'
import { Layout, SEO } from '../../components'
import BannerBox from '../../components/banner-box'
import { HeadLine, SubParagraph, Banner, SubmitBtn } from './components/atom'
import Billboard from '../../components/billboard'
import { Status } from './components/status'
import { Solution } from './components/solution'
import { Advantages } from './components/advantages'
import { Scence } from './components/scence'
import Icon1 from './components/images/education/1_3.svg'
import Icon2 from './components/images/education/2_3.svg'
import Icon3 from './components/images/education/4_3.svg'
import Icon4 from './components/images/visual/3.svg'
import Icon6 from './components/images/education/5_2.svg'
import Icon7 from './components/images/education/6_2.svg'
import Icon8 from './components/images/education/7_2.svg'
import Icon9 from './components/images/visual/9.svg'
import Icon10 from './components/images/visual/10.svg'
import Icon11 from './components/images/education/10_2.svg'
import Icon12 from './components/images/visual/12.svg'
import Icon13 from './components/images/3dtraining/security.svg'
import IconFeature1 from './components/images/education/classroom.svg'
import IconFeature2 from './components/images/visual/mechanical.svg'
import IconFeature3 from './components/images/education/online-education.svg'
import IconFeature4 from './components/images/visual/industrial.svg'
import IconFeature5 from './components/images/3dtraining/vr.svg'
import banckgroundImage from './components/images/3dtraining/solution.png'

const statusData = [
  {
    title: '桌面环境部署麻烦',
    description:
      '实训机房的需要机器逐台安装系统及部署设计软件，部署完后还需逐台机器进行软件注册，部署工作量大且效率低。',
    icon: Icon1,
  },
  {
    title: '无法统一管理设备资源',
    description:
      '实训室资源固定，不能根据课程所需资源进行机器配置的弹性伸缩。资源分配不灵活且利用率低。',
    icon: Icon2,
  },
  {
    title: '设备故障率高',
    description:
      '传统PC主机零部件多，单一组件损毁影响整台机器正常使用。实训室建设机器数量多且使用频率高，使机器故障率居高不下。',
    icon: Icon3,
  },
  {
    title: '无法便携式访问',
    description:
      '机器资源固定，只能在固定教室内使用机器资源。疫情期间无法将资源共享到公网，便于学生线上使用实训环境或提供给老师进行科研任务。',
    icon: Icon4,
  },
]

const solutionData = {
  description:
    '青椒云3D实训室解决方案，专门针对3D实训室场景。方案学生端采用瘦终端替换原有的PC主机，将实训室内的所有运算资源统一部署在后端数据中心的服务器上。服务器内安装青椒云虚拟化平台，将服务器物理硬件资源进行虚拟化，生成多台虚拟机，再通过网络方式将虚拟机分发到各个业务场景内，将桌面交付给学生使用。管理员通过web界面登录青椒云管理平台，即可实现对全校的实训室设备资源进行部署和管理。极大提升管理员的设备管理能力和运维效率。',
  icon: banckgroundImage,
}

const advantageData = [
  {
    title: '支持多种大型设计软件',
    description:
      '支持3DMAXS、MAYA、SolidWorks、Rhino、Sumatra等。可提供高性能图形处理能力，多种高性能显卡按需选择',
    icon: Icon6,
  },
  {
    title: '支持多种分辨率',
    description: '支持720P、1080、2K，最大支持4K分辨率',
    icon: Icon7,
  },
  {
    title: '画面高清流畅',
    description: '支持30FPS、60FPS，最高支持120FPS，支持H264、H265视频编码格式',
    icon: Icon8,
  },
  {
    title: '支持USB外设',
    description: '支持USB外设，如加密狗、U盾、手绘板等',
    icon: Icon9,
  },
  {
    title: '支持多云主机连接',
    description: '一台终端，教学、制作、渲染三不误',
    icon: Icon10,
  },
  {
    title: '自由切换终端',
    description: '无缝切换终端，应用程序和数据不间断运行，永久保存在云端',
    icon: Icon11,
  },
  {
    title: '高速传输',
    description: '自研协议高速传输，实现本地与云桌面教学文件快速传输共享',
    icon: Icon12,
  },
  {
    title: '安全认证',
    description: '取得美国（MPAA）和内容交付与安全协会（CDSA）的TPN认证、云数据中心ISO安全认证',
    icon: Icon13,
  },
]

const scenceData = [
  {
    title: 'BIM设计实训室',
    icon: IconFeature1,
    col: 6,
    md: 3,
  },
  {
    title: '机械设计实训室',
    icon: IconFeature2,
    col: 6,
    md: 3,
  },
  {
    title: '影视制作实训室',
    icon: IconFeature3,
    col: 6,
    md: 3,
  },
  {
    title: '工业设计实训室',
    icon: IconFeature4,
    col: 6,
    md: 3,
  },
  {
    title: '虚拟机仿真实训室',
    icon: IconFeature5,
    col: 6,
    md: 3,
  },
]

const handelContact = () => {
  if (document.querySelector('#nb_invite_ok')) {
    document.querySelector('#nb_invite_ok').click()
  }
}

const TrainingRoom = () => {
  const isWide = useMedia({ minWidth: 992 })

  return (
    <Layout>
      <SEO
        title='云电脑-云桌面,您的移动图形工作站,一站式云电脑服务平台-青椒云'
        keywords='云电脑,云桌面,图形工作站,桌面云'
        description='青椒云桌面,提供一站式云电脑服务,打造未来的移动图形工作站,解决电脑配置低无法制作和高效渲图的问题,轻松实现实时渲染,适用于教育,影视,设计,办公等领域'
      />
      <StaticQuery
        query={graphql`
          query {
            banner: file(relativePath: { eq: "banner/3dtraining_bg.png" }) {
              childImageSharp {
                fluid(maxWidth: 1920, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        `}
        render={data => (
          <BannerBox>
            <Billboard fluid={data.banner.childImageSharp.fluid} />
            <Banner>
              <HeadLine>教育3D专业实训室解决方案</HeadLine>
              <SubParagraph>
                青椒云图形工作站是面向中职、高职和高校开设的BIM建筑设计、机械设计、影视制作、工业设计、虚拟仿真，提出的高性能3D专业实训室解决方案。{' '}
                <br />
                方案采用VDI的云桌面架构，通过桌面虚拟化技术与计算机教室完美结合，使得环境部署集中化、管理智能化、维护简单化。相比于传统的物理主机方案，青椒云图形工作站拥有更强劲的3D性能体验、更快捷的环境部署、更便捷的桌面管理、更低的设备故障率、更符合教育信息化2.0下的专业实训室建设。本方案在VDI桌面虚拟化的基础上配备业内领先的QDP音视频传输协议，是当前行业内画面延时低、帧率高、性能体验好的教育3D专业实训室解决方案。
              </SubParagraph>
              <SubmitBtn onClick={handelContact}>联系我们</SubmitBtn>
            </Banner>
          </BannerBox>
        )}
      />
      <Status menuData={statusData} title='传统PC实训室建设存在问题' />
      <Solution
        menuData={solutionData}
        customizeStyle={
          isWide
            ? {
                height: 556,
                maxWidth: 854,
                margin: '30px auto 0',
              }
            : {
                height: '57vw',
                maxWidth: '89vw',
                margin: '12px auto 0',
              }
        }
      />
      <Advantages menuData={advantageData} />
      <Scence type='3d' menuData={scenceData} />
    </Layout>
  )
}

export default TrainingRoom
